import axios from '../axios';
import { apiPaths } from '../helper/apiPaths';
import { errMsg, errMsgNoData } from '../helper/functions';
import { ErrorResponseType } from '../types';
import {
  AnnualReviewAuditTrail,
  AnnualReviewCycle,
  AnnualReviewCycleDetails,
  AnnualReviewUsers,
} from '../types/AnnualReview';

const getAllAnnualReviewCyclesCode = import.meta.env
  .VITE_GET_ALL_ANNUAL_REVIEW_CYCLES;

const getAnnualReviewCycleByIdCode = import.meta.env
  .VITE_GET_ANNUAL_CYCLE_BY_ID;

const createAnnualReviewCycleCode = import.meta.env
  .VITE_CREATE_ANNUAL_REVIEW_CYCLE;

const updateAnnualReviewCycleCode = import.meta.env
  .VITE_UPDATE_ANNUAL_REVIEW_CYCLE;

const getAllAnnualReviewCycleDetailsCode = import.meta.env
  .VITE_GET_ALL_ANNUAL_REVIEW_CYCLE_DETAILS;

const getAnnualReviewAuditTrailCode = import.meta.env
  .VITE_GET_ANNUAL_REVIEW_AUDIT_TRAIL;

export const getAllAnnualReviewCycles = async (mode: 'hr' | 'mentor') => {
  const ret: { data: AnnualReviewCycle[]; error: ErrorResponseType | null } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.cycles}?code=${getAllAnnualReviewCyclesCode}&mode=${mode}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const getAllAnnualReviewCycleUsers = async (
  cycleId: string,
  mode: 'hr' | 'mentor'
) => {
  const ret: { data: AnnualReviewUsers[]; error: ErrorResponseType | null } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.annualReviewUserStatus}/${cycleId}?mode=${mode}&code=${getAllAnnualReviewCycleDetailsCode}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const getAnnualCycleById = async (id: string, mode: 'hr' | 'mentor') => {
  const ret: { data: AnnualReviewCycle; error: ErrorResponseType | null } = {
    data: {} as AnnualReviewCycle,
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.cycles}/${id}?mode=${mode}&code=${getAnnualReviewCycleByIdCode}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const createAnnualReviewCycle = async (
  payload: AnnualReviewCycleDetails
) => {
  const ret: { data: AnnualReviewCycle[]; error: ErrorResponseType | null } = {
    error: null,
    data: [],
  };
  try {
    const { data } = await axios.post(
      `${apiPaths.cycles}/?code=${createAnnualReviewCycleCode}`,
      payload
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const updateAnnualReviewCycle = async (
  id: string,
  payload: AnnualReviewCycleDetails
) => {
  const ret: { data: AnnualReviewCycle[]; error: ErrorResponseType | null } = {
    error: null,
    data: [],
  };
  try {
    const { data } = await axios.put(
      `${apiPaths.cycles}/${id}?code=${updateAnnualReviewCycleCode}`,
      payload
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const getAnnualReviewAuditTrail = async (userReviewId: string) => {
  const ret: {
    error: ErrorResponseType | null;
    data: AnnualReviewAuditTrail[];
  } = {
    error: null,
    data: [],
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.annualReviewAuditTrail}/${userReviewId}?code=${getAnnualReviewAuditTrailCode}`
    );
    if (data) ret.data = data;
    else ret.error = errMsgNoData();
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};
